module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_vm._l((_vm.shoppinglists), function(list, index) {
    return _c('li', {
      class: index === 0 ? 'active' : '',
      attrs: {
        "role": "presentation"
      }
    }, [_c('shopping-list-title-component', {
      attrs: {
        "id": list.id,
        "title": list.title
      }
    })], 1)
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.addShoppingList
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-plus-sign"
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, _vm._l((_vm.shoppinglists), function(list, index) {
    return _c('div', {
      staticClass: "tab-pane",
      class: index === 0 ? 'active' : '',
      attrs: {
        "role": "tabpanel",
        "id": list.id
      }
    }, [_c('shopping-list-component', {
      attrs: {
        "id": list.id,
        "title": list.title,
        "items": list.items
      }
    })], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f1cfde7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 59
// module chunks = 1